"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportSalesOrdersProgressResponse = void 0;
class ImportSalesOrdersProgressResponse {
}
exports.ImportSalesOrdersProgressResponse = ImportSalesOrdersProgressResponse;
//# sourceMappingURL=import-sales-orders-progress.response.js.map